
      <div class="row">

        <div class="col-md-12 padding-left-0px padding-right-0px">
         
            <div class="card postion-fixed-labsetup2">
              <div class="row">

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-header wh-header border-bottom ">
                      <div class="row">
                        <!--<div class="col-md-1">
                          <a (click)="BackToServices()"><i class="fas fa-angle-double-left"></i></a>
                        </div>-->
                        <div class="col-md-9">
                          <label class="label-size-2">{{ testInfo?.Name || ServiceName || 'ACA IGG' }}</label>
                        </div>
                        </div>
                      <div class="row" *ngIf="SelectedService">
                        <div class="col-md-3">
                          <label class="label-size-2 font-size-1rem">{{ testInfo?.DepartmentName || DepartmentName || 'Lab' }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="card-body padding-top-15px height-500px" *ngIf="SelectedService">
                      <div class="row">
                        <div class="card margin-left-auto margin-right-auto width-802px">
                          <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px">
                            <div class="row">
                              <div class="col-md-4">
                                <label>Test Information</label>
                              </div>
                              <div class="col-md-8 float-right text-align-end">
                                <a class="nav-link-hand education-navlink" (click)="edittestmodal()">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="card-body ">
                            <div class="row">
                              <div class="col-md-6 border-right">
                                <div class="row">
                                  <div class="col-md-6  text-align-right">
                                    <label for="firstName" class="font-size-14px">Code </label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.TestCode || ServiceCode || 1 }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Name </label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.Name || ServiceName || 'ACA IGG' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Short Name </label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.ShortName || 'ACAIGG' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Department </label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.DepartmentName || DepartmentName || 'Lab' }}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Patient Age Profile</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.PatientAgeProfile || 'Female' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Test Availability</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.TestAvailability || 'External Lab' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6  text-align-right">
                                    <label for="firstName" class="font-size-14px">Service Mapping </label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.ServiceMapping || ServiceCode || '16' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Test Type </label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ testInfo?.TestType || 'General' }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="card margin-left-auto margin-right-auto width-802px  margin-top-12px">
                          <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px ">
                            <div class="row">
                              <div class="col-md-6 padding-right-0px">
                                <label>Specimens</label>
                              </div>
                              <div class="col-md-6 float-right text-align-end">
                                <a class="nav-link-hand education-navlink" (click)="editspecimenmodal()">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="card-body ">
                            <div class="row">
                              <div class="col-md-6 border-right">
                                <div class="row">
                                  <div class="col-md-6  text-align-right">
                                    <label for="firstName" class="font-size-14px">Is Specimen Available</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <input type="checkbox" class="checkbox1" [checked]="specimen?.IsSpecimenAvailable !== undefined ? specimen?.IsSpecimenAvailable : true" disabled />
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Specimen Source</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ specimen?.SpecimenSource || 'Serum' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Quantity</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ specimen?.Quantity !== undefined ? specimen?.Quantity : 5 }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">UOM</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ specimen?.UOM || 'ML' }}</label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Organizm</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ specimen?.Organism || '' }}</label>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6 text-align-right">
                                    <label for="firstName" class="font-size-14px">Has Test method</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <input type="checkbox" class="checkbox1" [checked]="specimen?.HasTestMethod" disabled />
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6  text-align-right">
                                    <label for="firstName" class="font-size-14px">Test method(kit)</label>
                                  </div>:
                                  <div class="col-md-5 text-align-left">
                                    <label class="font-size-14px">{{ specimen?.TestMethod || '' }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="card margin-left-auto margin-right-auto width-802px  margin-top-12px">
                          <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px ">
                            <div class="row">
                              <div class="col-md-4">
                                <label>Observations</label>
                              </div>
                              <div class="col-md-8 float-right text-align-end">
                                <a (click)="observationmodal()" class="nav-link-hand education-navlink">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="card-body padding-top-0 padding-left-0px padding-bottom-0px">
                            <div class="card alerts-note-form ">
                              <div class="card-body padding-top padding-left-8 padding-right-9" *ngIf="ShowList">
                                <div class="table-component">
                                  <div class="table-responsive overflow-x">
                                    <table class="table table-striped margin-left-zero">
                                      <thead class="">
                                        <tr>
                                          <th class="">Order Seq.</th>
                                          <th class="">Name</th>
                                          <th class="">Examination Type</th>
                                          <th class="">UOM</th>
                                          <th class="">Observation Group</th>
                                          <th class=""> </th>
                                        </tr>
                                      </thead>
                                      <tbody class="table-body">
                                        <tr *ngFor="let obs of observationsList; let i = index">
                                          <td class="text-align-center">{{ obs.OrderSeq || (i + 1) }}</td>
                                          <td class="">{{ obs.Name || obs.name }}</td>
                                          <td class="">{{ obs.ExaminationType || obs.examinationType }}</td>
                                          <td class="text-align-center">{{ obs.UOM || obs.uom }}</td>
                                          <td class="">{{ obs.ObservationGroup || obs.observationGroup }}</td>
                                          <td class="">
                                            <a class="font-size-14px nav-link-hand rowfor1" (click)="rangemodal(obs)">Range</a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="card margin-left-auto margin-right-auto width-802px  margin-top-12px">
                          <div class="card-header wh-header header3 card-header-bg padding-top-6px padding-bottom-6px ">
                            <div class="row">
                              <div class="col-md-4">
                                <label>Notes</label>
                              </div>
                              <div class="col-md-8 float-right text-align-end">
                                <a (click)="addnotesmodal()" class="nav-link-hand education-navlink">
                                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="card-body padding-top-0 padding-left-0px padding-bottom-0px">
                            <div class="card alerts-note-form ">
                              <div class="card-body padding-top padding-left-8 padding-right-9" *ngIf="ShowList">
                                <label>{{ notesText || 'Add Notes Here...' }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


            </div>


         


        </div>
      </div>
     

    
  


